module.exports = __webpack_public_path__ + "img/20201107_204037.46c2cb53.jpg";